/**
 * クレジットカードに関する情報を返却する
 */

var CreditCard = CreditCard || {};

/**
 * 使用できるクレジットカードの情報を返却
 *
 * @return Deferred
 */
CreditCard.getCreditCard = function () {
    var defer = $.Deferred();
    $.ajax({
        url: '/service/credit-card.json',
        method: 'GET',
        success: defer.resolve,
        error: defer.reject
    });

    return defer.promise();
};

/**
 * GMO 外部js使用可否の判定
 */
CreditCard.isEnabledMultiPayment = function () {
    return typeof Multipayment !== 'undefined';
}

/**
 * GMO Token取得
 */
CreditCard.getGMOToken = function (shopId, cardNo, expire, holderName, callbackName) {
    Multipayment.init(shopId);
    return Multipayment.getToken({
      cardno:     cardNo,
      expire:     expire,
      holdername: holderName
    }, callbackName);
};

/**
 * エラーコードからエラー情報を生成して返却
 */
CreditCard.getError = function (code) {
    var error = { type: '', message: ''};
    switch (code + '') {
      case '000':
        error.type    = '';
        error.message = '';
        break;
      case '100':
        error.type    = 'cardNo';
        error.message = 'カード番号を入力してください';
        break;
      case '101': case '102':
        error.type    = 'cardNo';
        error.message = 'カード番号は半角数字10～16文字で入力してください';
        break;
      case '110':
        error.type    = 'expire';
        error.message = '有効期限を入力してください';
        break;
      case '111': case '112': case '113':
        error.type    = 'expire';
        error.message = '有効期限を正しく入力してください';
        break;
      case '121': case '122':
        error.type    = 'securityCode';
        error.message = 'セキュリティコードは半角数字4文字以内で入力してください';
        break;
      case '131': case '132':
        error.type    = 'holderName';
        error.message = '名義人は半角英数字・スペース・カンマ・ピリオド・ハイフン・スラッシュ50文字以内で入力してください';
        break;
      case 'gmo_js_disabled':
          error.type    = 'gmo';
          error.message = '処理に失敗しました。お手数ですがページを再読み込みの上、再度お試し下さい';
          break;
      default:
        error.type    = 'gmo';
        error.message = '処理に失敗しました。お手数ですが再度お試し下さい';
    }
    return error;
};

